export default "__VITE_ASSET__D_EuTkzG__"